import { useContext } from "react";

import { EditBoardGroupPanelContext } from "./EditBoardGroupPanelContext";

export function useEditBoardGroupPanel() {
  const context = useContext(EditBoardGroupPanelContext);
  if (!context) {
    throw new Error("useEditBoardGroupPanel must be used within a EditBoardGroupPanelProvider");
  }
  return context;
}
